import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// Material UI
import Hidden from 'material-ui/Hidden';
import Drawer from 'material-ui/Drawer';
import { withStyles } from 'material-ui/styles';

// Styles
import styles from './styles';

// Components
import DrawerMenu from './components/DrawerMenu';

// Actions
import { openSideDrawer } from './actions';

class SideDrawer extends Component {
  render(){
    const { classes, theme } = this.props;
    return(
      <div>
        <Hidden mdUp>
          <Drawer
            type="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={this.props.sideDrawerOpen}
            classes={{
              paper: classes.drawerPaper,
            }}
            onRequestClose={() => this.props.openSideDrawer(false)}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <DrawerMenu />
          </Drawer>
        </Hidden>

        <Hidden mdDown implementation="css">
          <Drawer
            type="permanent"
            open
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <DrawerMenu />
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

SideDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        sideDrawerOpen: state.dashboard.sideDrawerOpen,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      openSideDrawer: openSideDrawer,
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(SideDrawer)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/index.js